<template>
  <v-dialog v-model="value" scrollable persistent max-width="400">
    <v-card>
      <v-card-title class="headline">
        <v-icon large color="error">{{icon}}</v-icon>
        {{title}}
      </v-card-title>
      <v-card-text>
        {{text}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn ref="btnCancel" color="info" flat="flat" @click="cancel">
          取消
        </v-btn>

        <v-btn ref="btnOk" color="success" @click="submit">
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>

<script>
  import GhConfirmDialog from "./ghConfirmDialog.ts";
  export default GhConfirmDialog;
</script>